import { render, staticRenderFns } from "./setList.vue?vue&type=template&id=3f32d95c&"
import script from "./setList.vue?vue&type=script&lang=js&"
export * from "./setList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports